import APICall from "../utils/APICall";

export default class UserServices {
  static userLogin = async (payload) => {
    return await APICall("/api/User/admin/login", "POST", payload);
  };
  static unBlockAccount = async (userName) => {
    return await APICall(
      `/api/User/admin/unlockAccount?userName=${userName}`,
      "GET"
    );
  };
  static createUser = async (payload) => {
    return await APICall("/api/User/admin/create-user", "POST", payload);
  };

  static listUser = async (page, pageLimit, search) => {
    var url = `/api/User/admin/listUsers?page=${page}&pageLimit=${pageLimit}`;
    if (search) url = `${url}&search=${search}`;
    return await APICall(url, "GET");
  };

  static exportList = async (search, adminType) => {
    return await APICall(
      `/api/User/admin/export-Users?search=${search}&adminType=${adminType}`,
      "GET"
    );
  };

  static viewDetails = async (payload) => {
    return await APICall(`/api/User/admin/viewUser?userName=${payload}`, "GET");
  };
  static activateUser = async (userName) => {
    return await APICall("/api/User/admin/activate-Users", "POST", userName);
  };
  static authToken = async (payload) => {
    return await APICall("/api/User/admin/auth-validation", "POST", payload);
  };
  static disableUser = async (payload) => {
    return await APICall("/api/User/admin/disable-user", "POST", payload);
  };
  static editUser = async (payload) => {
    return await APICall("/api/User/admin/update-users", "POST", payload);
  };
}
